import * as React from 'react';
import { Link } from 'react-router-dom';

import { ClientLogger } from 'bernie-client';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

const logger = ClientLogger.getLoggerWithIdentifier('pwa.component.doublelink');
const SAFE_OPENER_REL = 'noopener noreferrer';

interface DoubleLinkProps {
  target?: string;
  to?: string; // Required to function properly, but the component will return an empty link without it
}

export class DoubleLink extends React.Component<DoubleLinkProps> {
  constructor(props) {
    super(props);

    if (!props.to) {
      logger.logEvent(
        new SystemEvent(SystemEventLevel.WARN, 'DOUBLE_LINK_MISSING_PROP'),
        'Missing prop: DoubleLink missing props.to'
      );
    }
  }

  public render() {
    const localLinkProps = {};
    const { to, target, children } = this.props;
    if (target) {
      localLinkProps['rel'] = SAFE_OPENER_REL;
    }

    if (!to || to.indexOf('http') === -1) {
      return (
        <Link {...localLinkProps} {...this.props} to={to || ''}>
          {children}
        </Link>
      );
    }

    return (
      <a {...localLinkProps} href={to} {...this.props}>
        {children}
      </a>
    );
  }
}
